import { createEvent, createStore } from 'effector'
import { createGate } from 'effector-react'

import {
  DEFAULT_SETTINGS_GREETINGS_LIST_PAGE_TAB,
  type SettingsGreetingsListPageTabsKeys,
} from '../lib/tabs'

// Gate
export const SettingsGreetingsListPageGate = createGate()

// Tab
export const settingsGreetingsListPageTabChanged =
  createEvent<SettingsGreetingsListPageTabsKeys>()
export const $settingsGreetingsListPageTab =
  createStore<SettingsGreetingsListPageTabsKeys>(
    DEFAULT_SETTINGS_GREETINGS_LIST_PAGE_TAB,
  ).on(settingsGreetingsListPageTabChanged, (_, payload) => payload)
